import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loader2 } from "lucide-react";
import { air } from "./api";
import { CentresPanel } from "./CentresPanel";
import { TestConsole } from "./TestConsole";
import { LeadsPanel } from "./LeadsPanel";
import { DashboardPanel } from "./DashboardPanel";
import { CostReport } from "./CostReport";
import { CentreAnswersPanel } from "./CentreAnswersPanel";

export default function AiReceptionistTab({ session }) {
  const token = session.token;
  const [meta, setMeta] = useState(null);
  const load = useCallback(() => air("centres", token).then(setMeta).catch((e) => toast.error(e.message)), [token]);
  useEffect(() => { load(); }, [load]);
  if (!meta) return <div className="flex justify-center p-8"><Loader2 className="animate-spin" /></div>;
  const sa = meta.is_super_admin;
  return (
    <div className="space-y-3" data-testid="ai-receptionist-tab">
      <div>
        <h2 className="text-lg font-semibold">AI Receptionist</h2>
        <p className="text-xs text-muted-foreground">Answers routine calls on each centre's existing number, records enquiries for managers and hands important calls to a person. Callers are always told they are speaking with an AI assistant.</p>
      </div>
      <Tabs defaultValue="leads">
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="leads" data-testid="air-tab-leads">Call Leads</TabsTrigger>
          <TabsTrigger value="dashboard" data-testid="air-tab-dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="console" data-testid="air-tab-console">Test Console</TabsTrigger>
          <TabsTrigger value="centres" data-testid="air-tab-centres">Centres</TabsTrigger>
          {sa && <TabsTrigger value="answers" data-testid="air-tab-answers">Centre Answers</TabsTrigger>}
          {sa && <TabsTrigger value="costs" data-testid="air-tab-costs">Cost &amp; Feasibility</TabsTrigger>}
        </TabsList>
        {sa && <TabsContent value="answers"><CentreAnswersPanel token={token} /></TabsContent>}
        <TabsContent value="leads"><LeadsPanel token={token} centres={meta.centres} /></TabsContent>
        <TabsContent value="dashboard"><DashboardPanel token={token} centres={meta.centres} /></TabsContent>
        <TabsContent value="console"><TestConsole token={token} centres={meta.centres} /></TabsContent>
        <TabsContent value="centres"><CentresPanel token={token} meta={meta} reload={load} /></TabsContent>
        {sa && <TabsContent value="costs"><CostReport token={token} /></TabsContent>}
      </Tabs>
    </div>
  );
}
